import $ from 'jquery';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-de';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-en-GB';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-zh-CN';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-es';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-fr';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-it';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-pl';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-ja';
import 'jquery-ui-datepicker-with-i18n/ui/i18n/jquery.ui.datepicker-tr';

export default function localizeDatepicker(languageCode) {
  if (languageCode !== 'us') {
    const map = { en: 'en-GB', zh: 'zh-CN' };
    const lang = map[languageCode] || languageCode;
    $.datepicker.setDefaults($.datepicker.regional[lang]);
  }
}
